import { render } from "./PropertyListComponentRaiseIssue.vue?vue&type=template&id=0626c5ea&scoped=true&ts=true"
import script from "./PropertyListComponentRaiseIssue.vue?vue&type=script&lang=ts"
export * from "./PropertyListComponentRaiseIssue.vue?vue&type=script&lang=ts"

import "./PropertyListComponentRaiseIssue.vue?vue&type=style&index=0&id=0626c5ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0626c5ea"]])

export default __exports__